var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41033 3.96226C3.34672 3.96226 4.10581 3.20316 4.10581 2.26677C4.10581 1.33038 3.34672 0.571289 2.41033 0.571289C1.47394 0.571289 0.714844 1.33038 0.714844 2.26677C0.714844 3.20316 1.47394 3.96226 2.41033 3.96226Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82323 5.09473H0.997425C0.84144 5.09473 0.714844 5.22132 0.714844 5.37731V13.8547C0.714844 14.0107 0.84144 14.1373 0.997425 14.1373H3.82323C3.97922 14.1373 4.10581 14.0107 4.10581 13.8547V5.37731C4.10581 5.22132 3.97922 5.09473 3.82323 5.09473Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2446 4.62453C11.0368 4.21083 9.52617 4.57423 8.62021 5.22586C8.58913 5.10435 8.47835 5.01393 8.34667 5.01393H5.52086C5.36488 5.01393 5.23828 5.14052 5.23828 5.29651V13.7739C5.23828 13.9299 5.36488 14.0565 5.52086 14.0565H8.34667C8.50266 14.0565 8.62925 13.9299 8.62925 13.7739V7.68149C9.0859 7.28814 9.67424 7.16267 10.1558 7.36726C10.6226 7.5645 10.8899 8.04602 10.8899 8.68748V13.7739C10.8899 13.9299 11.0165 14.0565 11.1725 14.0565H13.9983C14.1543 14.0565 14.2809 13.9299 14.2809 13.7739V8.11836C14.2487 5.79611 13.1562 4.9365 12.2446 4.62453Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.960c2d764dcd38c970d2d2552ed39a9b.svg";
export { ForwardRef as ReactComponent };